import { faeRequestUrls } from "@/utils/messageUrl";
import http from "./httpVideo";
import { FAESearchForm } from "@/types/technical";
import { BaseResponseType, MessageCenterListBaseResponseResultType } from "@/types/message";

const { get, post } = http;

/**
 * 获取fae 工单列表
 * @param {FAESearchForm} params 
 * @returns 
 */
export const getFAEOrderList = (params: FAESearchForm={}):Promise<BaseResponseType<MessageCenterListBaseResponseResultType<any[]>>> => {
  return post(`${faeRequestUrls.getFAEOrderList}`, params,{
    headers:{
      'Content-Type': 'application/json'
    }
  });
}
/**
 * 获取fae 状态列表
 * @returns 
 */
export const getFAEOrderStatusList= < T=any >():Promise<BaseResponseType<T>> => {
  return get(`${faeRequestUrls.getFAEOrderStatusList}`);
}
/**
 * 查询fae 工单详情
 * @param id 
 * @returns 
 */
export const getFAEOrderDetail = (id:number):Promise<BaseResponseType<any>> => {
  return get(`${faeRequestUrls.getFAEOrderDetail}?id=${id}`);
}

/**
 * 获取用户 fae 项目详情
 * @returns 
 */
export const getFAEProjectDetail= ():Promise<BaseResponseType<any>> => {
  return get(`${faeRequestUrls.getFAEProjectDetail}`);
}
/**
 * 提交fae工单
 * @param params 
 * @returns 
 */
export const submitFAEOrder = (params:any):Promise<BaseResponseType<any>> => {
  return post(`${faeRequestUrls.submitFAEOrder}`, params,{
    headers:{
      'Content-Type': 'application/json'
    }
  });
}


/**
 * 上传文件
 * @param params 
 * @param config 
 * @returns 
 */
export const uploadFile = (params: any,config:any):Promise<BaseResponseType> => {
  return post(`${faeRequestUrls.uploadFile}`, params,{
    ...config,
    timeout:10*60*1000
  });
}
/**
 * 更新fae工单
 */
export const updateFAEOrder= (params:any):Promise<BaseResponseType> => {
  return post(`${faeRequestUrls.updateFAEOrder}`, params,{
    headers:{
      'Content-Type': 'application/json'
    }
  });
}
/**
 * 获取工单分类
 * @returns 
 */
export const getFAEOrderCategory= (type:string):Promise<BaseResponseType<any>> => {
  return get(`/community-api/community/ticket/category?type=${type}`);
}
/**
 * 关闭工单
 * @param id 
 * @returns 
 */
export const closeFAEOrder= (id:number):Promise<BaseResponseType> => {
  return get(`${faeRequestUrls.closeFAEOrder}?id=${id}`);
}
/**
 * 追加评论
 * @param params 
 * @returns 
 */
export const addComment= (params:{parentId:number,content:string}):Promise<BaseResponseType> => {
  return post(`${faeRequestUrls.addComment}`, params,{
    headers:{
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 获取权限
 * @returns 
 */
export const getPermission= ():Promise<BaseResponseType<any>> => {
  return get(`${faeRequestUrls.getPermission}`);
}